import { defineMessages } from 'react-intl';

export default defineMessages({
  propertyId: {
    id: 'admanagement.property.propertyId',
    defaultMessage: 'Property ID',
  },
});
